import { useGlobalStore } from '@stores/global'
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../../tailwind.config.js'

const fullConfig = resolveConfig(tailwindConfig)

function getCurrentBreakpoint(width) {
	const breakpoints = fullConfig.theme.screens
	const sortedBreakpoints = Object.entries(breakpoints)
		.map(([name, value]) => ({
			name,
			value: parseInt(value),
		}))
		.sort((a, b) => b.value - a.value)

	for (const breakpoint of sortedBreakpoints) {
		if (width >= breakpoint.value) {
			return breakpoint.name
		}
	}

	return 'xs'
}

export function initResponsive() {
	const globalStore = useGlobalStore()

	if (typeof window !== 'undefined') {
		const currentWidth = window.innerWidth
		const currentBreakpoint = getCurrentBreakpoint(currentWidth)

		globalStore.setScreenWidth(currentWidth)
		globalStore.setBreakpoint(currentBreakpoint)

		const updateWidth = () => {
			const newWidth = window.innerWidth
			const newBreakpoint = getCurrentBreakpoint(newWidth)

			globalStore.setScreenWidth(newWidth)
			globalStore.setBreakpoint(newBreakpoint)
		}

		window.addEventListener('resize', updateWidth)

		return () => {
			window.removeEventListener('resize', updateWidth)
		}
	}

	return () => {}
}
